import React, { useCallback, useContext } from 'react'
import Textarea from 'react-textarea-autosize'
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { v4 } from 'uuid'
import classNames from 'classnames'
import { useForm } from 'react-hook-form'

import { deleteAction, addAction, updateAction } from 'Actions/flow'
import { StepContext } from 'Src/containers/contexts'
import { hasNonWhitelistedTags } from 'Utils/html'
import { DEFAULT_WHITELISTED_TAGS } from 'Src/constants'

const MessageEdit = (props) => {
  const { mode = 'edit', text = '', actionId, cancelFn = _.noop, disableOptions = false, isFirstAction = false } = props

  const dispatch = useDispatch()
  const { stepId } = useContext(StepContext)
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues: { message: text }
  })

  const canShowDeleteBtn = mode === 'edit'

  const editMessage = useCallback(
    (text) => {
      dispatch(
        updateAction({
          stepId,
          actionId,
          setting: {
            type: 'message',
            text
          }
        })
      )
      cancelFn()
    },
    [dispatch, cancelFn, stepId, actionId]
  )

  const createMessage = useCallback(
    (text) => {
      dispatch(
        addAction({
          stepId,
          actionId: v4(),
          setting: {
            type: 'message',
            text
          }
        })
      )
    },
    [dispatch, stepId]
  )

  const onSaveClick = useCallback(
    (data) => {
      const value = data.message.trim()

      if (mode === 'create') {
        createMessage(value)
      } else {
        editMessage(value)
      }

      cancelFn()
    },
    [cancelFn, mode, createMessage, editMessage]
  )

  const onDeleteClick = useCallback(() => {
    dispatch(
      deleteAction({
        stepId,
        actionId
      })
    )
  }, [dispatch, actionId, stepId])

  const handleKeyDown = (e) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(onSaveClick)()
    }
  }

  const validateMessage = (value) => {
    if (hasNonWhitelistedTags(value)) {
      return `Message should contain only <${DEFAULT_WHITELISTED_TAGS.join('>, <')}> tags`
    }
  }

  return (
    <form onSubmit={handleSubmit(onSaveClick)}>
      <div className='form-group'>
        <Textarea
          maxRows={8}
          minRows={3}
          className='form-control'
          onKeyDown={handleKeyDown}
          placeholder={isFirstAction ? 'Start with a message...' : 'Type a message...'}
          {...register('message', {
            required: 'Message is required',
            validate: validateMessage
          })}
        />
        {errors.message && <small className='form-text text-danger'>{errors.message.message}</small>}
      </div>
      {!disableOptions && (
        <div className='options'>
          <button className={classNames('button-primary small save', { right: isFirstAction })} type='submit'>
            Save
          </button>
          {!isFirstAction && (
            <button type='button' className='btn cancel' onClick={cancelFn}>
              Cancel
            </button>
          )}
          {canShowDeleteBtn && (
            <button type='button' className='btn delete' onClick={onDeleteClick}>
              Delete
            </button>
          )}
        </div>
      )}
    </form>
  )
}

export default MessageEdit
